import { useEffect } from "react";
import { hasOpenOverlay, hasTransientPopupOpen } from "@/hooks/useOverlayDismiss";
import { shouldHandleAppChord } from "@/lib/keyboardShortcuts";

/**
 * Opens the global Add menu on `a` when focus is not in a typing control.
 * Item actions use single-key chords while the menu is open.
 */
export default function useOpenGlobalAddMenuShortcut({
  onOpenAddMenu,
  enabled = true
}: {
  onOpenAddMenu?: () => void;
  enabled?: boolean;
}) {
  useEffect(() => {
    if (!enabled || !onOpenAddMenu) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (!shouldHandleAppChord(event)) return;
      if (event.key.toLowerCase() !== "a") return;
      if (hasOpenOverlay() || hasTransientPopupOpen()) return;
      if (document.body.dataset.goNavMode === "true") return;

      event.preventDefault();
      onOpenAddMenu();
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [enabled, onOpenAddMenu]);
}
